import Swal from 'sweetalert2';
import Vue from 'vue';

export default {
    message: function (title) {
        Swal.fire({
            title
        });
    },
    messageWithTitle: function (title, text, icon = 'success') {
        Swal.fire({
            title,
            text,
            icon
        });
    },
    messageWithFunction: function (title, text, icon, okFunc) {
        icon = icon === "" || icon === null || icon === undefined ? "success" : icon;
        Swal.fire({
            title,
            text,
            confirmButtonColor: '#4466f2',
            icon
        }).then((result) => {
            if (okFunc !== undefined && okFunc !== null)
                okFunc();
        });
    },
    confirm: function (title, text, icon, okFunc, cancelFunc, confirmButtonText = 'Tamam', cancelButtonText = 'İptal') {
        icon = icon === "" || icon === null || icon === undefined ? "success" : icon;
        Swal.fire({
            title,
            text,
            icon,
            showCancelButton: true,
            confirmButtonText,
            confirmButtonColor: '#4466f2',
            cancelButtonText,
            cancelButtonColor: '#4466f2',
        }).then((result) => {
            if (result.isConfirmed) {
                if (okFunc !== undefined && okFunc !== null)
                    okFunc();
            } else if (result.isDismissed) {
                if (cancelFunc !== undefined && cancelFunc !== null)
                    cancelFunc();
            }
        });
    },

    firlat: function (message, type, duration = 2000, position = 'bottom-right', theme = "outline") {
        Vue.toasted.show(message, { theme, position, type, duration });
    }
}